import Vue from 'vue'

// Lib imports
import axios from 'axios'

// @TODO: Implement Vuex Store
// import store from '@/store'
import Router from 'vue-router'

const router = new Router()

const config = axios

const API_URL = process.env.VUE_APP_URL || '/'
config.defaults.baseURL = API_URL

config.defaults.headers.common.Accept = 'application/json'

/* Set The Token if Present So We Can Authorize Request */
const accessToken = localStorage.getItem('access_token')
if (accessToken) {
  config.defaults.headers.common.csToken = `${accessToken}`
}

// Interceptors to Handle invalid token of user
config.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      // @TODO: Implement Vuex Store
      // store.dispatch('resetUser')
      router.push({ path: '/' })
    }

    if (error.response.status === 406) {
      router.push({ path: '/404' })
    }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = config
